/* src/app/components/payroll/timesheets/timesheet-staff-authdata/timesheet-staff-authdata.component.css */
.custom-font-size {
  font-size: 14px !important;
}
.hyperlink {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
/*# sourceMappingURL=timesheet-staff-authdata.component-OXUACCPM.css.map */
